import axios from "axios";
import '../utils/axios.interceptor';
import { urlCoreBack, urlBucketBack } from "../configs/config";
const epName = "v1/anteojo-sol/";
const epNameBucket = "v1/bucket/";
const nameItemsText = "Anteojos de Sol";
const nameItemText = "Anteojo de Sol";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getAnteojosSol = async (params) => {
	let _params = {};
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

	if (params) {
		if (params.codigo) {
			_params.codigo = params.codigo;
		}
		if (params.idArAsMarca) {
			_params.id_ar_as_marca = params.idArAsMarca;
		}
		if (params.modelo) {
			_params.modelo = params.modelo;
		}
		if (params.codigoExterno) {
			_params.codigo_externo = params.codigoExterno;
		}
		if (params.descripcion) {
			_params.descripcion = params.descripcion;
		}
		if (params.idArAsCategoria) {
			_params.id_ar_as_categoria = params.idArAsCategoria;
		}
		if (params.idArAsMaterial) {
			_params.id_ar_as_material = params.idArAsMaterial;
		}
		if (params.idArAsFormato) {
			_params.id_ar_as_formato = params.idArAsFormato;
		}
		if (params.idArAsCalibre) {
			_params.id_ar_as_calibre = params.idArAsCalibre;
		}
		if (params.idArAsTipo) {
			_params.id_ar_as_tipo = params.idArAsTipo;
		}
		if (params.idAsColorLente) {
			_params.id_as_color_lente = params.idAsColorLente;
		}
		if (params.idArAsColor) {
			_params.id_ar_as_color = params.idArAsColor;
		}
		if (params.colorList) {
			for (let i = 0; i < params.colorList.length; i++) {
				_params.color_list = params.colorList[i];
			}
		}

		if (params.estado) {
			let estado =
				params.estado === "habilitado"
					? "H"
					: params.estado === "deshabilitado"
						? "D"
						: "";
			_params.habilitado = estado;
		}
		if (params.rows) {
			_params.rows = params.rows;
		}
		if (params.first) {
			_params.first = params.first;
		}
	}

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: _params,
		});
		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}
		// si hay algun error controlado
		console.log(_errorMessage);
		console.log(response);
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};

export const getAnteojoSol = async (params) => {
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;
	if (params) {
		if (params.id) {
			params.id = params.id;
		}
	}
	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: params,
		});
		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}
		// si hay algun error controlado
		console.log(_errorMessage);
		console.log(response);
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};

//
// #############################################################################
//
export const saveAnteojoSol = async (actionCrud, item) => {
	let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;
	let _lsColorList = []
	let _lsCodigoExternoList = []
	let _lsOrigenCristalList = []
	let _lsFotoList = []
	let _files = []

	if (item.lsColorList) {
		item.lsColorList.forEach((item) => {
			_lsColorList.push({
				id_ar_as_color: item.id
			});
		});
	}
	if (item.lsCodigoExternoList) {
		item.lsCodigoExternoList.forEach((item) => {
			_lsCodigoExternoList.push({
				id_proveedor: item.id_proveedor,
				codigo_externo: item.codigo_externo,
			});
		});
	}
	if (item.lsOrigenCristalList) {
		item.lsOrigenCristalList.forEach((item) => {
			_lsOrigenCristalList.push({
				id_cr_origen: item.id
			});
		});
	}
	if (item.lsFotoList) {
		item.lsFotoList.forEach((item) => {
			_lsFotoList.push({
				id_s3: item.id_s3
			}
			);
			_files.push({
				id_s3: item.id_s3,
				file: item.archivo,
			});
		});
	}

	const sendToBucket = async () => {
		for (const file of _files) {
			let formData = new FormData();
			formData.append("file", file.file);
			formData.append("metadata", JSON.stringify({ id_s3_list: [{ id_s3: file.id_s3 }] }));
			let bucketResponse = await axios({
				method: "POST",
				url: `${urlBucketBack}${epNameBucket}`,
				data: formData,
			});
			if (bucketResponse.statusText === 'OK')
				continue;
			else {
				console.error('Error al subir el archivo:', bucketResponse);
				return {
					ok: false,
					messageText: `Error al subir el archivo: ${bucketResponse}`,
					messageSeverity: "error",
				};
			}
		}
	}

	// Asegurar que las listas siempre sean arrays, incluso si están vacías
	// Esto previene que el minificador elimine propiedades con arrays vacíos
	const _codigoExternoList = Array.isArray(_lsCodigoExternoList) ? _lsCodigoExternoList : [];
	const _colorList = Array.isArray(_lsColorList) ? _lsColorList : [];
	const _cristalOrigenList = Array.isArray(_lsOrigenCristalList) ? _lsOrigenCristalList : [];
	const _fotoIdS3List = Array.isArray(_lsFotoList) ? _lsFotoList : [];

	// Construir el objeto de manera explícita para evitar optimizaciones del minificador
	let _item = {};
	_item.codigo = item.codigo;
	_item.descripcion = item.descripcion;
	_item.modelo = item.modelo;
	_item.id_ar_as_categoria = item.idArAsCategoria;
	_item.id_ar_as_material = item.idArAsMaterial;
	_item.id_ar_as_formato = item.idArAsFormato;
	_item.id_ar_as_calibre = item.idArAsCalibre;
	_item.id_ar_as_tipo = item.idArAsTipo;
	_item.id_ar_as_marca = item.idArAsMarca;
	_item.id_as_color_lente = item.idAsColorLente;
	_item.id_usuario = localStorage.getItem("id_usuario");
	_item.ubicacion = item.ubicacion;
	_item.existencia_minima = item.existenciaMinima;
	_item.punto_pedido = item.puntoPedido;
	_item.existencia_maxima = item.existenciaMaxima;
	_item.observaciones = item.observaciones;
	_item.tipo_articulo = "anteojo-sol";
	_item.codigo_externo_list = _codigoExternoList;
	_item.color_list = _colorList;
	_item.cristal_origen_list = _cristalOrigenList;
	_item.foto_id_s3_list = _fotoIdS3List;
	if (actionCrud !== "new") {
		_item.id = item.id;
	}

	try {
		let response = {};
		if (actionCrud === "new") {
			response = await axios({
				method: "POST",
				url: `${urlCoreBack}${epName}`,
				data: _item,
			}
			);
		} else if (actionCrud === "update") {
			response = await axios({
				method: "PUT",
				url: `${urlCoreBack}${epName}`,
				data: _item,
			});
		} else if (actionCrud === "disable" || actionCrud === "enable") {
			response = await axios({
				method: "DELETE",
				url: `${urlCoreBack}${epName}`,
				params: {
					id: _item.id,
					id_usuario: localStorage.getItem("id_usuario"),
					action: actionCrud,
				},
			});
		}
		if (response.status === 200) {
			if (_files.length > 0) {
				await sendToBucket();
			}
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				response.messageText =
					`${nameItemText}` +
					(actionCrud === "disable"
						? itemGender === "M"
							? " deshabilitado"
							: " deshabilitada"
						: actionCrud === "enable"
							? itemGender === "M"
								? " habilitado"
								: " habilitada"
							: itemGender === "M"
								? " guardado"
								: " guardada");
				response.messageSeverity = "success";
			} else {
				// si hay error controlado
				console.log(_errorMessage);
				console.log(response);
				let _message_code = response.data.code;
				if (_message_code === "err-anteojo-sol-already-exist") {
					response.messageText = "Ya existe un Anteojo de Sol con la misma descripción";
				} else if (_message_code === "err-articulo-codigo-externo-codigo-externo-existente") {
					response.messageText = "Ya existe un Artículo con el mismo Código Externo del mismo Proveedor";
				} else if (_message_code === "err-articulo-lp-not-exist") {
					response.messageText = "No existe Lista de Precios para el Artículo";
				} else if (_message_code === "err-articulo-con-existencia-deshabilita-not-allowed") {
					response.messageText = "El Artículo tiene Existencias, no se puede deshabilitar";
				} else if (_message_code === "err-anteojo-sol-cristal-origen-list-required") {
					response.messageText = "Debes seleccionar el origen de los cristales";
				} else {
					response.messageText = _errorMessage;
				}
				response.ok = false;
				response.messageSeverity = "error";
			}
			return response;
		}
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
